<template>
    <Details/>
</template>
<script>
import details from '../components/request/RequestDetail.vue';

export default {
    components: {
        Details: details
    }
};
</script>
